<div class="sales-container">
    <div class="sales big-screen" *ngIf="data" [class.no-border]="loading$ | async">
        <div class="skeleton" *ngIf="loading$ | async"></div>
        <ng-container *ngFor="let tabLabel of infoToFill[selectedTab]; let last = last">
            <div class="total-sales" [class.p-paid-paid]="tabLabel.id === 'p.paid.paid'">
                <ng-container *ngIf="data">
                    <h3 *ngIf="(!tabLabel.id.startsWith('p.paid.') || tabLabel.id === 'p.paid.paid') && tabLabel.id !== 'p.pending.nc' && tabLabel.id !== 'c.pending.jobs' && tabLabel.id !== 'c.paid.jobs'"
                        class="currency"
                        [class.brown]="tabLabel.id === 'cc.pre-chargebacks.pre-chargebacks'"
                        [class.yellow]="tabLabel.id === 'cc.pre-chargebacks.arbitration'"
                        [class.red]="tabLabel.id === 'cc.chargebacks.chargebacks' || (tabLabel.id === 'cc.settled.settled' && data[tabLabel.property] < 0)"
                        [class.green]="tabLabel.id === 'cc.chargebacks.resolved'"
                        [attr.data-id]="tabLabel.id"
                        #tooltip="matTooltip"
                        [matTooltip]="''"
                        [hideTooltipOnScroll]="tooltip"
                        [shortNumber]="data[tabLabel.property] ?? 0 | currency"
                        [shortNumberTooltip]="tooltip"
                        (click)="tooltip.show()"
                    ></h3>
                    <h3 *ngIf="tabLabel.id.startsWith('p.paid.') && tabLabel.id !== 'p.paid.paid'"
                        #tooltip="matTooltip"
                        [matTooltip]="''"
                        [shortNumber]="round(data[tabLabel.property]) + '%'"
                        [shortNumberDecimals]="0"
                        [shortNumberTooltip]="tooltip"
                        [hideTooltipOnScroll]="tooltip"
                    ></h3>
                    <h3 *ngIf="tabLabel.id === 'p.pending.nc' || tabLabel.id === 'c.pending.jobs' || tabLabel.id === 'c.paid.jobs'"
                        #tooltip="matTooltip"
                        [matTooltip]="''"
                        [shortNumber]="data[tabLabel.property] ?? 0"
                        [shortNumberDecimals]="0"
                        [shortNumberTooltip]="tooltip"
                        [hideTooltipOnScroll]="tooltip"
                    ></h3>
                </ng-container>
                <small>{{ tabLabel.text }}</small>
                <h4
                    *ngIf="tabLabel.subproperty"
                    #tooltip="matTooltip"
                    [matTooltip]="''"
                    [shortNumber]="data[tabLabel.subproperty] ?? 0 | currency"
                    [shortNumberTooltip]="tooltip"
                    [hideTooltipOnScroll]="tooltip"
                    (click)="tooltip.show()"
                ></h4>
            </div>
            <div class="divider-line" *ngIf="!last"></div>
        </ng-container>
    </div>
    <div class="sales small-screen"
        [class.expanding]="expendings.includes(selectedTab)"
        [class.expand-animation]="showAll" *ngIf="data"
    >
        <div class="skeleton" *ngIf="loading$ | async"></div>
        <ng-container *ngFor="let tabLabel of infoToFill[selectedTab]; let last = last; let i = index">
            <div class="total-sales" [class.p-paid-paid]="tabLabel.id === 'p.paid.paid'">
                <small>{{ tabLabel.text }}</small>
                <div class="w-100 overflow-hidden d-flex justify-content-end align-items-center gap--8" *ngIf="data">
                    <h3 *ngIf="(!tabLabel.id.startsWith('p.paid.') || tabLabel.id === 'p.paid.paid') && tabLabel.id !== 'p.pending.nc' && tabLabel.id !== 'c.pending.jobs' && tabLabel.id !== 'c.paid.jobs'"
                        class="currency"
                        [class.brown]="tabLabel.id === 'cc.pre-chargebacks.pre-chargebacks'"
                        [class.yellow]="tabLabel.id === 'cc.pre-chargebacks.arbitration'"
                        [class.red]="tabLabel.id === 'cc.chargebacks.chargebacks' || (tabLabel.id === 'cc.settled.settled' && data[tabLabel.property] < 0)"
                        [class.green]="tabLabel.id === 'cc.chargebacks.resolved'"
                        [attr.data-id]="tabLabel.id"
                        #tooltip="matTooltip"
                        [matTooltip]="''"
                        [hideTooltipOnScroll]="tooltip"
                        [shortNumber]="data[tabLabel.property] ?? 0 | currency"
                        [shortNumberTooltip]="tooltip"
                        (click)="tooltip.show()"
                    ></h3>
                    <h3 *ngIf="tabLabel.id.startsWith('p.paid.') && tabLabel.id !== 'p.paid.paid'"
                        #tooltip="matTooltip"
                        [matTooltip]="''"
                        [shortNumber]="round(data[tabLabel.property]) + '%'"
                        [shortNumberDecimals]="0"
                        [shortNumberTooltip]="tooltip"
                        [hideTooltipOnScroll]="tooltip"
                    ></h3>
                    <h3 *ngIf="tabLabel.id === 'p.pending.nc' || tabLabel.id === 'c.pending.jobs' || tabLabel.id === 'c.paid.jobs'"
                        #tooltip="matTooltip"
                        [matTooltip]="''"
                        [shortNumber]="data[tabLabel.property] ?? 0"
                        [shortNumberDecimals]="0"
                        [shortNumberTooltip]="tooltip"
                        [hideTooltipOnScroll]="tooltip"
                    ></h3>
                    <div *ngIf="tabLabel.subproperty" class="divider-line"></div>
                    <h4
                        *ngIf="tabLabel.subproperty"
                        #tooltip="matTooltip"
                        [matTooltip]="''"
                        [shortNumber]="data[tabLabel.subproperty] ?? 0 | currency"
                        [shortNumberTooltip]="tooltip"
                        [hideTooltipOnScroll]="tooltip"
                        (click)="tooltip.show()"
                    ></h4>
                </div>
            </div>
        </ng-container>
        <app-icon *ngIf="infoToFill[selectedTab].length > 1 && expendings.includes(selectedTab)"
            class="se-icon-button no-bg no-hover"
            [class.transform]="showAll" src="cheveron_down"
            width="24" height="24"
            (click)="toggleShowAll()"
        ></app-icon>
    </div>
</div>
